import { ElDropdown } from 'element-plus/es';
import 'element-plus/es/components/dropdown/style/css';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-087abe0d"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "home-view"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "el-dropdown-link"
}, " 选项 ", -1));
const _hoisted_3 = {
  class: "header"
};
const _hoisted_4 = {
  class: "h_left"
};
const _hoisted_5 = {
  class: "h_left_t"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "实时大屏 ", -1));
const _hoisted_7 = [_hoisted_6];
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "平台统计", -1));
const _hoisted_9 = [_hoisted_8];
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "用户行为分析", -1));
const _hoisted_11 = [_hoisted_10];
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "客户终端分析", -1));
const _hoisted_13 = [_hoisted_12];
const _hoisted_14 = {
  class: "h_right"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "商品分析", -1));
const _hoisted_16 = [_hoisted_15];
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "类目分析", -1));
const _hoisted_18 = [_hoisted_17];
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "区域分析", -1));
const _hoisted_20 = [_hoisted_19];
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 产品流向分析 ", -1));
const _hoisted_22 = [_hoisted_21];
const _hoisted_23 = {
  class: "h_centre"
};
const _hoisted_24 = {
  key: 0
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-jia"
}, null, -1));
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "返回首页", -1));
const _hoisted_27 = [_hoisted_25, _hoisted_26];
const _hoisted_28 = {
  class: "main"
};
import { reactive, ref } from "@vue/reactivity";
import { onMounted, onUpdated } from "@vue/runtime-core";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView3',
  setup(__props) {
    const title = ref('方舟控股 集药方舟网上药房');
    // const hactive: computed(() => store.state.hactive);
    const stata = reactive({
      issearch3: ref(false)
    });
    const $router = useRouter();
    const $route = useRoute();
    // const store = useStore();
    const {
      state,
      commit,
      dispatch
    } = useStore();
    onMounted(() => {
      pathactive3();
      methods.getSearch();
    });
    if ($route.path == '/plane') {
      title.value = '方舟控股 · 生态增长飞轮';
    }
    onUpdated(() => {
      pathactive3();
    });
    // 头部 菜单的点击事件
    const bindheader = pathname => {
      if ($route.path == `/${pathname}`) return;
      $router.push(`/${pathname}`);
      commit("UpActive", pathname);
    };
    // 保持头部的 当前的激活
    const pathactive3 = () => {
      let pathactive3 = $route.path.split("/")[1];
      // console.log(pathactive3);
      commit("UpActive", pathactive3);
    };
    let methods = {
      getSearch() {
        var url = decodeURI(window.location.search);
        if (url.indexOf("?") != -1) {
          var str = url.substr(1); //得到?后面的字符串
          // var strs = str.split("&");
          let a = RegExp(/search=1/);
          stata.issearch3 = a.test(str);
        }
      },
      goRealTime() {
        $router.push("/");
        stata.issearch3 = false;
      },
      // 选项下拉的点击事件
      ElDropdown(e) {
        let $index = e.target.dataset.index;
        if ($index == 2) {
          // 退出首页
          $router.push('/');
        }
      }
    };
    return (_ctx, _cache) => {
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dropdown, {
        "hide-on-click": false,
        class: "logout"
      }, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, {
          onClick: _unref(methods).ElDropdown
        }, {
          default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
            "data-index": "2"
          }, {
            default: _withCtx(() => [_createTextVNode("退出")]),
            _: 1
          })]),
          _: 1
        }, 8, ["onClick"])]),
        default: _withCtx(() => [_hoisted_2]),
        _: 1
      }), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("ul", _hoisted_5, [_createElementVNode("li", {
        class: _normalizeClass({
          active: _unref(state).hactive == 'pharmacy'
        }),
        onClick: _cache[0] || (_cache[0] = $event => bindheader('pharmacy'))
      }, _hoisted_7, 2), _createElementVNode("li", {
        class: _normalizeClass([{
          active: _unref(state).hactive == 'plane'
        }, {
          active: _unref(state).hactive == 'plane2'
        }, {
          active: _unref(state).hactive == 'plane3'
        }]),
        onClick: _cache[1] || (_cache[1] = $event => bindheader('plane'))
      }, _hoisted_9, 2), _createElementVNode("li", {
        class: _normalizeClass([{
          active: _unref(state).hactive == 'useraction'
        }, {
          active: _unref(state).hactive == 'useraction2'
        }]),
        onClick: _cache[2] || (_cache[2] = $event => bindheader('useraction'))
      }, _hoisted_11, 2), _createElementVNode("li", {
        class: _normalizeClass([{
          active: _unref(state).hactive == 'client'
        }]),
        onClick: _cache[3] || (_cache[3] = $event => bindheader('client'))
      }, _hoisted_13, 2)])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("ul", null, [_createElementVNode("li", {
        class: _normalizeClass([{
          active: _unref(state).hactive == 'plarproduct'
        }, {
          active: _unref(state).hactive == 'plarproduct2'
        }, {
          active: _unref(state).hactive == 'plarproduct3'
        }]),
        onClick: _cache[4] || (_cache[4] = $event => bindheader('plarproduct'))
      }, _hoisted_16, 2), _createElementVNode("li", {
        class: _normalizeClass([{
          active: _unref(state).hactive == 'plarcategory'
        }, {
          active: _unref(state).hactive == 'plarcategory2'
        }]),
        onClick: _cache[5] || (_cache[5] = $event => bindheader('plarcategory'))
      }, _hoisted_18, 2), _createElementVNode("li", {
        class: _normalizeClass([{
          active: _unref(state).hactive == 'plarregional'
        }]),
        onClick: _cache[6] || (_cache[6] = $event => bindheader('plarregional'))
      }, _hoisted_20, 2), _createElementVNode("li", {
        class: _normalizeClass([{
          active: _unref(state).hactive == 'plarflow'
        }, {
          active: _unref(state).hactive == 'plarflow2'
        }, {
          active: _unref(state).hactive == 'plarflow3'
        }]),
        onClick: _cache[7] || (_cache[7] = $event => bindheader('plarflow'))
      }, _hoisted_22, 2)])]), _createElementVNode("div", _hoisted_23, [_createElementVNode("p", null, _toDisplayString(_unref(title)), 1), _unref(title) == '方舟控股 · 生态增长飞轮' ? (_openBlock(), _createElementBlock("p", _hoisted_24, "ARK HOLDINGS · ECOLOGICAL GROWTH FLYWHEEL")) : _createCommentVNode("", true)]), _unref(stata).issearch3 ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "homepage",
        onClick: _cache[8] || (_cache[8] =
        //@ts-ignore
        (...args) => _unref(methods).goRealTime && _unref(methods).goRealTime(...args))
      }, _hoisted_27)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_28, [_createVNode(_component_router_view)])]);
    };
  }
});